// John Ward Interiors — Shopify theme interactions
// Ported from the static prototype; cart/variant/gift-card wiring added for Shopify.
document.addEventListener('DOMContentLoaded', () => {

  // Mega menu — swap the feature image/label to match the hovered/focused category.
  // Shopify nav links won't carry data-mega-img, so this degrades to the static feature image.
  document.querySelectorAll('.mega').forEach((mega) => {
    const links = mega.querySelectorAll('.mega-links a');
    const img = mega.querySelector('.mega-feature-img');
    const label = mega.querySelector('.mega-feature-label');
    const card = mega.querySelector('.mega-feature-card');
    const linksWrap = mega.querySelector('.mega-links');
    if (!img || !links.length) return;
    const defaultSrc = img.getAttribute('src');
    const defaultLabel = label ? label.textContent : '';
    const defaultHref = card ? card.getAttribute('href') : null;
    const defaultAlt = img.getAttribute('alt') || '';
    const setFeature = (link) => {
      const src = link.dataset.megaImg;
      const lbl = link.dataset.megaLabel;
      const url = link.dataset.megaUrl;
      if (src) img.setAttribute('src', src);
      if (lbl) {
        if (label) label.textContent = `Shop ${lbl}`;
        img.setAttribute('alt', `Shop ${lbl}`);
      }
      if (url && card) card.setAttribute('href', url);
    };
    links.forEach((link) => {
      link.addEventListener('mouseenter', () => setFeature(link));
      link.addEventListener('focus', () => setFeature(link));
    });
    // Bind mouseleave/reset to the whole mega container (not just the links list) so
    // moving the cursor from the links list onto the feature card to click it doesn't
    // prematurely reset the href back to the default before the click registers.
    mega.addEventListener('mouseleave', () => {
      img.setAttribute('src', defaultSrc);
      img.setAttribute('alt', defaultAlt);
      if (label) label.textContent = defaultLabel;
      if (card && defaultHref) card.setAttribute('href', defaultHref);
    });
  });

  // Accordion (product page)
  document.querySelectorAll('.accordion-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      trigger.closest('.accordion-item').classList.toggle('open');
    });
  });

  // Gallery thumbnail swap (product page)
  const galleryMain = document.querySelector('.gallery-main img');
  document.querySelectorAll('.gallery-thumbs button').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumbs button').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      const thumb = btn.querySelector('img');
      if (galleryMain && thumb) galleryMain.src = thumb.dataset.full || thumb.src;
    });
  });

  // Quantity stepper (product page)
  document.querySelectorAll('.qty-stepper').forEach((stepper) => {
    const input = stepper.querySelector('input');
    stepper.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        let val = parseInt(input.value, 10) || 1;
        val += btn.dataset.action === 'inc' ? 1 : -1;
        if (val < 1) val = 1;
        input.value = val;
      });
    });
  });

  // Mobile nav toggle
  const navToggle = document.querySelector('.nav-toggle');
  const mainNav = document.querySelector('.main-nav');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', () => mainNav.classList.toggle('nav-open'));
  }

  // Sort/filter chips — visual toggle only
  document.querySelectorAll('.filter-chip').forEach((chip) => {
    chip.addEventListener('click', () => chip.classList.toggle('active'));
  });

  // Department scroll-hint arrow
  document.querySelectorAll('.dept-scroll-wrap').forEach((wrap) => {
    const track = wrap.querySelector('.dept-scroll');
    if (!track) return;
    const updateHint = () => {
      const canScroll = track.scrollWidth > track.clientWidth + 4;
      const atStart = track.scrollLeft <= 8;
      wrap.classList.toggle('hint-hidden', !canScroll || !atStart);
    };
    updateHint();
    track.addEventListener('scroll', updateHint, { passive: true });
    window.addEventListener('resize', updateHint);
  });

  // ---- Shopify variant picker ----
  // Swatches carry data-variant-id (single-option) or the picker reads all option groups.
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantData = form.querySelector('[data-variant-json]');
    let variants = [];
    if (variantData) {
      try { variants = JSON.parse(variantData.textContent); } catch (e) { variants = []; }
    }
    const idInput = form.querySelector('[name="id"]');
    const priceEl = form.querySelector('[data-price]');
    const addBtn = form.querySelector('[data-add-btn]');
    const selected = {};

    const findVariant = () => variants.find((v) =>
      (v.option1 == null || v.option1 === selected['1']) &&
      (v.option2 == null || v.option2 === selected['2']) &&
      (v.option3 == null || v.option3 === selected['3'])
    );

    const formatMoney = (cents) => '$' + (cents / 100).toFixed(2);

    const update = () => {
      const v = findVariant();
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (addBtn) {
          if (v.available) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart — ' + formatMoney(v.price); }
          else { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
        }
      }
    };

    form.querySelectorAll('.swatches').forEach((group) => {
      const optIndex = group.dataset.optionIndex;
      group.querySelectorAll('.swatch, .swatch-color').forEach((el) => {
        if (el.classList.contains('active') && optIndex) selected[optIndex] = el.dataset.value;
        el.addEventListener('click', () => {
          group.querySelectorAll('.swatch, .swatch-color').forEach((s) => s.classList.remove('active'));
          el.classList.add('active');
          if (optIndex) selected[optIndex] = el.dataset.value;
          const labelValue = group.closest('.option-group').querySelector('.option-label span:last-child');
          if (labelValue) labelValue.textContent = el.dataset.value || el.textContent.trim();
          update();
        });
      });
    });
    update();
  });

  // ---- Gift card recipient toggle (native digital delivery) ----
  const gcToggle = document.querySelector('[data-gc-toggle]');
  const gcFields = document.querySelector('[data-gc-fields]');
  if (gcToggle && gcFields) {
    const sync = () => {
      gcFields.classList.toggle('open', gcToggle.checked);
      gcFields.querySelectorAll('[data-required-when-on]').forEach((el) => {
        if (gcToggle.checked) el.setAttribute('required', 'required');
        else el.removeAttribute('required');
      });
    };
    gcToggle.addEventListener('change', sync);
    sync();
  }

  // ---- Real AJAX add-to-cart ----
  const cartCountEl = document.querySelector('.cart-count');
  const refreshCartCount = async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if (cartCountEl) cartCountEl.setAttribute('data-count', cart.item_count);
    } catch (e) { /* ignore */ }
  };

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      // Only intercept if it's an AJAX-capable product form (not gift-card recipient which posts to /cart/add normally too)
      e.preventDefault();
      const btn = form.querySelector('[data-add-btn]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error('add failed');
        await refreshCartCount();
        if (btn) { btn.textContent = 'Added ✓'; setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1600); }
      } catch (err) {
        if (btn) { btn.textContent = original; btn.disabled = false; }
        window.location.href = '/cart';
      }
    });
  });
});
